import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { DatabaseService } from './database.service';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  key:string = 'token';
  
  constructor(
    private dbService: DatabaseService,
  ) { }

  getToken(key?) {
    return this.dbService.get(key || this.key);
  }

  setToken(token) {
    let now = new Date();
    let seconds = 60 * 60 * 12;
    let expires = new Date(now.getTime() + 1000 * seconds);
    this.dbService.set('token',token, expires);
  }

  removeToken() {
    this.dbService.delete(this.key);
  }

  getUserId() {
    return this.getTokenDecode().id;
  }

  getUserData() {
	  return this.getTokenDecode();
  }

  getBusinessData(){
    const business = this.dbService.get('business');
    return business;
  }

  isTokenValid(){
    return new Promise<any>((resolve) => {
      const jwtHelper = new JwtHelperService();
      const token = this.getToken();
      let decodedToken;
      try{
        decodedToken = jwtHelper.decodeToken(token);
        if(!decodedToken || jwtHelper.isTokenExpired(token)){
          return resolve(false);
        }
        resolve(true);
      }catch(e){
        resolve(false);
      }
    });
  }

  private getTokenDecode() {
    const helper = new JwtHelperService();
    const token = this.getToken();
    let decodedToken
    try {
      decodedToken = helper.decodeToken(token);
      if (decodedToken && helper.isTokenExpired(token)) {
        throw {error: 'Session expired'}
      }
    } catch (e) {
      throw { error:e }
    }
    return decodedToken;
  }
}
